import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  imports: [
    ToastrModule.forRoot({
      timeOut: 2500,
      enableHtml: true,
      positionClass: 'toast-top-right'
    })
  ],
  exports: [ToastrModule]
})
export class ToastModule { }
